import { CashbackBonusType, UserBonus } from 'config/types/bonus/userBonus'
import Box from 'UIKit/Box/Box'
import CashbackBonusContent from '../ActiveBonusContent/WageringBonusContent/CashbackBonusContent'
import BonusItemName from '../Common/BonusItemName'

interface UsedCashbackBonusContentProps {
  bonus: CashbackBonusType
}

const UsedCashbackBonusContent: React.FC<UsedCashbackBonusContentProps> = ({ bonus }) => {
  return (
    <Box height="100%">
      <BonusItemName bonus={bonus as UserBonus} mb="8px" />
      <CashbackBonusContent bonus={bonus} />
    </Box>
  )
}
export default UsedCashbackBonusContent
